import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable, useSearchParameter } from "hooks";
import { useMemo } from "react";
/* eslint-disable react-hooks/exhaustive-deps */
import { useSearchParams } from "react-router-dom";

import { useTransactions, TransactionsRequestParams } from "../apis";
import {
  DATE_RANGE_FILTER_SEARCH_PARAMETER,
  STATUS_FILTER_SEARCH_PARAMETER,
  TOTAL_FROM_FILTER_SEARCH_PARAMETER,
  TOTAL_TO_FILTER_SEARCH_PARAMETER,
  TransactionStatus
} from "../constants";

const useTransactionsList = (resellerId?: string) => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const [searchParams] = useSearchParams();
  const [amountFrom] = useSearchParameter(TOTAL_FROM_FILTER_SEARCH_PARAMETER);
  const [amountTo] = useSearchParameter(TOTAL_TO_FILTER_SEARCH_PARAMETER);

  const requestParams: TransactionsRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      orderBy: sorting[0]?.id ?? null,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC",
      resellerId,
      statuses:
        searchParams
          .getAll(STATUS_FILTER_SEARCH_PARAMETER)
          .map((status) => status as TransactionStatus) ?? undefined,
      amountFrom: amountFrom ? Number(amountFrom) : undefined,
      amountTo: amountTo ? Number(amountTo) : undefined,
      createdAtFrom:
        searchParams.getAll(DATE_RANGE_FILTER_SEARCH_PARAMETER)[0] ?? undefined,
      createdAtTo:
        searchParams.getAll(DATE_RANGE_FILTER_SEARCH_PARAMETER)[1] ?? undefined
    }),
    [page, debouncedSearch, sorting, searchParams, amountFrom, amountTo]
  );

  const {
    transactions,
    meta,
    isLoading,
    refetch: refetchOrders
  } = useTransactions(requestParams);

  return {
    transactions,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchOrders
  };
};

export default useTransactionsList;
